<vue-page-header [pageTitle]="'label.forgotPassword'| translate | async"
                 [previousPageTitle]="'title.Login' | translate | async"
                 (previousPageButtonClicked)="goToLogin()">
</vue-page-header>

<div class="full-width">
    <div class="row">
        <div class="panel-container col-xs-12 col-sm-10 col-sm-push-1">
            <vue-server-messages [messages]="messages"></vue-server-messages>
        </div>
    </div>
</div>

<div class="full-width">
    <div class="row">
        <div class="panel-container col-xs-12 col-sm-10 col-sm-push-1">
            <vue-stepper [activeStepIndex]="stepIndex">
                <!-- Verify Identity -->
                <vue-step
                        [heading]="
            'usernameLookup.group1Heading' | translate| async
          "
                >
                    <ng-container vueStepActiveContent>
                        <form #initiatePasswordResetForm="ngForm" class="app-form" novalidate>
                            <vue-control-group [label]="'field.Username' | translate| async"
                                               [control]="userName"
                                               [formError]="formError">
                                <input type="text"
                                       class="form-control"
                                       name="userName"
                                       required
                                       vueAutofocus
                                       #inputElement
                                       #userName="ngModel"
                                       [(ngModel)]="inputUserName"
                                />
                            </vue-control-group>
                            <div *ngIf="appDefaultsService.getLoginSiteIDRequired()">
                                <vue-control-group [label]="'field.SiteID' | translate| async"
                                                   [control]="siteID"
                                                   [formError]="formError">
                                    <input type="text"
                                           class="form-control"
                                           name="siteID"
                                           required
                                           #inputElement
                                           #siteID="ngModel"
                                           [(ngModel)]="inputSiteID"
                                    />
                                </vue-control-group>
                            </div>
                            <vue-form-buttons
                                    [defaultPosition]="'btn-left'"
                                    [primaryLabel]="'button.Verify' | translate| async"
                                    (primaryButtonClicked)="verifyUser()"
                            ></vue-form-buttons>
                        </form>
                    </ng-container>
                    <div vueStepCompleteContent>
                        <div class="form-group read-only">
                            <label class="control-label">
                                {{ "field.Username" | translate | async }}
                            </label>
                            <div class="input-container">
                                <span>{{ inputUserName }}</span>
                            </div>
                        </div>
                        <div class="form-group read-only">
                            <label class="control-label">
                                {{ "field.SiteID" | translate | async }}
                            </label>
                            <div class="input-container">
                                <span>{{ inputSiteID }}</span>
                            </div>
                        </div>
                    </div>
                    </vue-step>
                <vue-step
                        [heading]="
            'forgotPassword.userSelectionGroupHeading'
              | translate
              | async
          "
                >
                    <div vueStepPendingContent>
                        <p class="empty-state">
                            {{
                            "forgotPassword.section2.emptyStateMessage"
                                    | translate
                                    | async
                            }}
                        </p>
                    </div>
                 <ng-container vueStepActiveContent>
                        <vue-control-group
                                [control]="requiredRadio"
                                [formError]="formError"
                        >
                            <mat-radio-group
                                    class="cust-mat-radio-group"
                                    name="requiredRadio"
                                    required="true"
                                    #inputElement
                                    #requiredRadio="ngModel"
                                    [(ngModel)]="isEmailSelection"
                            >
                                <mat-radio-button value="true"
                                >
                                    <label class="control-label">
                                        {{ "forgotPassword.optionSendEmail" | translate:'Connect' :[userEmail]| async }}
                                    </label>

                                </mat-radio-button>
                                <mat-radio-button *ngIf="questionPromptGroups && questionPromptGroups.length > 0"

                                        value="false"
                                >
                                    <label class="control-label">
                                        {{ "groupHeader.answerSecurityQuestions" | translate| async }}
                                    </label>
                                </mat-radio-button>
                            </mat-radio-group>
                        </vue-control-group>

                        <!-- Answer Security Questions -->

                        <vue-security-questions *ngIf="isEmailSelection == 'false'"
                                                mode="answer"
                                                [questionPromptGroups]="questionPromptGroups"
                                                (answered)="questionsAnswered($event)"
                                                [formError]="formError"

                        ></vue-security-questions>
                    </ng-container>
                </vue-step>
            </vue-stepper>
        </div>
    </div>
    <div class="full-width">
        <div class="row">
            <div class="panel-container col-xs-12 col-sm-10 col-sm-push-1">
                <section role="menu">
                    <div class="panel-step-content">
                        <div class="panel panel-default">
                            <div class="panel-body">
                                <vue-form-buttons
                                        standalone="true"
                                        [primaryLabel]="
                    'label.passwordReset.changePassword' | translate| async
                  "
                                        (primaryButtonClicked)="resetPassword()"
                                        [primaryVisible]="stepIndex === 1"
                                        [secondaryLabel]="
                    'label.forgotUsername' | translate| async
                  "
                                        (secondaryButtonClicked)="goToUsernameLookup()"
                                        [defaultLabel]="
                    'label.cancel' | translate| async
                  "
                                        defaultPosition="btn-left"
                                        (defaultButtonClicked)="cancel()"
                                >
                                </vue-form-buttons>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</div>




